export const createAction = actionType => payload => ({
  type: actionType,
  payload,
});
